import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import {WithdrawalConsumerInterface} from "../../../../store-management/model/withdrawal-consumer-interface.type";
import {TouchScanWizardService} from "../touch-scan-wizard/touch-scan-wizard.service";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {GERMAN_LAYOUT} from "../../../../core/visbos-core/ui/directives/on-screen-keyboard.directive";
import {KeyboardOptions} from "virtual-keyboard";
import {getDefaultWithdrawalReason, WITHDRAWAL_REASONS} from "../../../../store-management/withdrawal-reasons.enum";


@Component({
  selector: 'vb-scan-consumer',
  templateUrl: './scan-consumer.component.html',
  styleUrls: ['./scan-consumer.component.css']
})
export class ScanConsumerComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  withdrawalReasons = WITHDRAWAL_REASONS;

  defaultReason() {
    return getDefaultWithdrawalReason();
  }

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Output()
  consumerSelected: EventEmitter<WithdrawalConsumerInterface> = new EventEmitter();

  allowedScanTypes = ['AdministrationUnit', 'Vehicle', 'Client'];

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              public scanWizardService: TouchScanWizardService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  onSelectReason(reason: string) {
    this.scanWizardService.selectWithdrawalReason(reason);
    this.cd.detectChanges();
  }

  onSelectConsumer(consumer: WithdrawalConsumerInterface) {
    let consumerType = '';

    switch (consumer.__typename) {
      case 'AdministrationUnit':
        consumerType = 'Standort';
        break;
      case 'Vehicle':
        consumerType = 'Fahrzeug';
        break;
      case 'Client':
        consumerType = 'Klient';
        break;
      default:
        consumerType = '';
        break;
    }

    this.scanWizardService.selectConsumer(consumerType, consumer);

    this.consumerSelected.emit(consumer);

  }

  onNoteChanged(note) {
    this.scanWizardService.setWithdrawalNote(note);
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-scan/scan-consumer/scan-consumer.component.ts